export const getFeatureHighlightsContentfulId = () =>
  import.meta.env.VITE_FEATURE_HIGHLIGHTS_CONTENTFUL_ID;
